<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <app-card [hidHeader]="false" cardTitle="Pré - Cadastro" [options]="false" class="mb-4">
        <form [formGroup]="preCadastroForm" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-sm-6 col-xl-3">
              <div class="form-group">
                <label class="sub-title" for="razao_social">Razão Social</label>
                <input type="text" 
                       class="form-control" 
                       id="razao_social"
                       formControlName="razao_social"
                       placeholder="Digite a razão social">
                <div class="invalid-feedback" *ngIf="preCadastroForm.get('razao_social').invalid && preCadastroForm.get('razao_social').touched">
                  Razão social é obrigatória
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-xl-3">
              <div class="form-group">
                <label class="sub-title" for="nome_fantasia">Nome Fantasia</label>
                <input type="text" 
                       class="form-control" 
                       id="nome_fantasia"
                       formControlName="nome_fantasia"
                       placeholder="Digite o nome fantasia">
                <div class="invalid-feedback" *ngIf="preCadastroForm.get('nome_fantasia').invalid && preCadastroForm.get('nome_fantasia').touched">
                  Nome fantasia é obrigatório
                </div>
              </div>
            </div>
            <div class="col-sm-3 col-xl-3">
              <div class="form-group">
                <label class="sub-title" for="cnpj">CNPJ</label>
                <input type="text" 
                       class="form-control" 
                       id="cnpj"
                       formControlName="cnpj"
                       placeholder="Digite o CNPJ">
                <div class="invalid-feedback" *ngIf="preCadastroForm.get('cnpj').invalid && preCadastroForm.get('cnpj').touched">
                  CNPJ é obrigatório
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-xl-3">
              <div class="form-group">
                <label class="sub-title" for="email">Email</label>
                <input type="email" 
                       class="form-control" 
                       id="email"
                       formControlName="email"
                       placeholder="Digite o email">
                <div class="invalid-feedback" *ngIf="preCadastroForm.get('email').invalid && preCadastroForm.get('email').touched">
                  Email é obrigatório e deve ser válido
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-xl-3">
              <div class="form-group">
                <div class="custom-control custom-checkbox mt-4">
                  <input type="checkbox" 
                         class="custom-control-input" 
                         id="iS_EMPRESA_GESTORA"
                         formControlName="iS_EMPRESA_GESTORA">
                  <label class="custom-control-label" for="iS_EMPRESA_GESTORA">Empresa Gestora</label>
                </div>
              </div>
            </div>
          </div> 
      
          <div class="row mt-3">
            <div class="col-12">
              <button type="submit" 
                      class="btn btn-primary float-right"
                      [disabled]="!preCadastroForm.valid">
                <i class="feather icon-check-circle mr-2 f-18"></i>
                Solicitar Cadastro
              </button>
            </div>
          </div>
        </form>
      </app-card>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <app-card cardTitle="Empresas Cadastradas" blockClass="table-border-style" [options]="false">
        <div class="table-responsive">
          <div *ngIf="arrayTurma.length === 0" class="text-center p-4">
            <i class="feather icon-database f-24"></i>
            <p class="mt-2">Nenhuma empresa cadastrada</p>
          </div>
          <table *ngIf="arrayTurma.length > 0" datatable [dtOptions]="dtOptions" class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>ID</th>
                <th>Razão Social</th>
                <th>Nome Fantasia</th>
                <th>CNPJ</th>
                <th>Empresa Gestora</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of arrayTurma">
                <td>{{item.id}}</td>
                <td>{{item.razao_social}}</td>
                <td>{{item.nome_fantasia}}</td>
                <td>{{item.cnpj}}</td>
                <td>
                  <span [class]="'badge ' + (item.iS_EMPRESA_GESTORA ? 'badge-success' : 'badge-secondary')">
                    {{item.iS_EMPRESA_GESTORA ? 'Sim' : 'Não'}}
                  </span>
                </td>
                <td>
                  <span [class]="'badge ' + (item.status === 'Finalizado' ? 'badge-success' : 
                                         item.status === 'Em Andamento' ? 'badge-warning' : 
                                         'badge-danger')">
                    {{item.status}}
                  </span>
                </td>
                <td>
                  <button class="btn btn-sm btn-info mr-2" 
                          (click)="carregarEdicao(item)"
                          ngbTooltip="Visualizar">
                    <i class="feather icon-eye"></i>
                  </button>
                  <button class="btn btn-sm btn-success mr-2" 
                          (click)="completarCadastro(item)"
                          ngbTooltip="Completar Cadastro">
                    <i class="feather icon-check-circle"></i>
                  </button>
                  <button class="btn btn-sm btn-primary mr-2" 
                          (click)="mostrarUrl(item)"
                          ngbTooltip="Copiar URL">
                    <i class="feather icon-link"></i>
                  </button>
                  
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </app-card>
    </div>
  </div>
</div>

<!-- Modal para mostrar a URL -->
<ng-template #urlModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">URL de Acesso</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label for="urlInput">URL para completar o cadastro:</label>
      <div class="input-group">
        <input type="text" class="form-control" id="urlInput" [value]="urlCompletarCadastro" readonly>
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button" (click)="copiarUrl()">
            <i class="feather icon-copy"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
  